import { Component, OnInit } from '@angular/core';
import { ApiService } from 'src/app/service/index.service';
import { ChartOptions, ChartConfiguration, Chart } from 'chart.js';

@Component({
  selector: 'app-tablero',
  templateUrl: './tablero.component.html',
  styleUrls: ['./tablero.component.scss']
})
export class TableroComponent implements OnInit {

  totalVenta: number = 0;
  totalGanancia: number = 0;
  totalGastos: number = 0;
  totalIngresos: number = 0;
  totalVentaM: number = 0;
  totalGananciaM: number = 0;
  totalGastosM: number = 0;
  totalIngresosM: number = 0;

  stockValorizado: {
    al_costo: number;
    a_precio_lista: number;
    margen_potencial: number;
    margen_porcentaje: string;
  } = { al_costo: 0, a_precio_lista: 0, margen_potencial: 0, margen_porcentaje: '0%' };

  porVenta: number | string = 0;
  porGanancia: number | string = 0;
  porGastos: number | string = 0;

  statsYear: any[] = [];
  alerts: any[] = [];
  topProducts: any[] = [];
  topClients: any[] = [];

  evolutionVentas: any = { labels: [], data: [] };
  evolutionGastos: any = { labels: [], data: [] };

  ventasChartData: ChartConfiguration<'line'>['data'];
  gastosChartData: ChartConfiguration<'line'>['data'];

  balanceChartData: ChartConfiguration<'bar'>['data'];
  balanceChartOptions: ChartOptions<'bar'>;

  comparativoChartData: ChartConfiguration<'bar'>['data'];
  comparativoChartOptions: ChartOptions<'line'>;



  chartOptions: ChartOptions<'line'> = {
    responsive: true,
    plugins: {
      legend: {
        display: true,
        labels: {
          color: '#333',
          font: { size: 13 }
        }
      },
      tooltip: {
        callbacks: {
          label: (ctx) => `Monto: $${ctx.formattedValue}`
        }
      },
      title: {
        display: false
      }
    },
    scales: {
      x: {
        title: {
          display: true,
          text: 'Meses'
        }
      },
      y: {
        title: {
          display: true,
          text: 'Importe ($)'
        }
      }
    }
  };

  statsDay: any[] = [];
  statsMonth: any[] = [];

  cargando: boolean = true
  constructor(private wsdl: ApiService) { }

  ngOnInit() {
    this.find();
  }

  async find() {
    try {
      this.cargando = true
      const data = await this.wsdl.finTablero();
      // No hace falta parsear dos veces
      const res = JSON.parse(JSON.stringify(data));
      //const res = data;

      if (res.code == 200) {
        this.totalVenta = res.data.ventas;
        this.totalGanancia = res.data.ganancias;
        this.totalGastos = res.data.egresos;

        this.totalVentaM = res.data.ventasM;
        this.totalGananciaM = res.data.gananciasM;
        this.totalGastosM = res.data.egresosM;

        this.stockValorizado = {
          al_costo: res.data.capitalInvertido || 0,
          a_precio_lista: res.data.valorLista || 0,
          margen_potencial: res.data.margenPotencial || 0,
          margen_porcentaje: res.data.margenPorcentaje || '0%'
        };

        this.porVenta = ((this.totalVenta * 100) / (this.totalVentaM || 1));
        this.porGanancia = ((this.totalGanancia * 100) / (this.totalGananciaM || 1));
        this.porGastos = ((this.totalGastos * 100) / (this.totalGastosM || 1));

        this.porVenta = this.porVenta.toFixed(2);
        this.porGanancia = this.porGanancia.toFixed(2);
        this.porGastos = this.porGastos.toFixed(2);

        this.alerts = res.data.alertas || [];
        this.topProducts = res.data.topProductos || [];
        this.topClients = res.data.topClientes || [];
        this.statsYear = res.data.statsYear || [];

        this.evolutionVentas = {
          labels: res.data.evoVentas?.labels || [],
          data: res.data.evoVentas?.data || []
        };

        this.evolutionGastos = {
          labels: res.data.evoGastos?.labels || [],
          data: res.data.evoGastos?.data || []
        };

        this.ventasChartData = {
          labels: res.data.evoVentas?.labels || [],
          datasets: [
            {
              label: 'Ventas',
              data: res.data.evoVentas?.data || [],
              borderColor: '#28a745',
              backgroundColor: 'rgba(40,167,69,0.1)',
              fill: true,
              tension: 0.3,
              pointRadius: 4
            }
          ]
        };

        this.gastosChartData = {
          labels: res.data.evoGastos?.labels || [],
          datasets: [
            {
              label: 'Gastos',
              data: res.data.evoGastos?.data || [],
              borderColor: '#dc3545',
              backgroundColor: 'rgba(220,53,69,0.1)',
              fill: true,
              tension: 0.3,
              pointRadius: 4
            }
          ]
        };

        const labels = res.data.evoVentas?.labels || [];
        const ventas = res.data.evoVentas?.data || [];
        const gastos = res.data.evoGastos?.data || [];
        const ganancias = res.data.evoGanancias.data || [];
        const ingresos = res.data.evoIngresos.data || [];

        const balance = ingresos.map((v, i) => v - (gastos[i] || 0));
        /*
                this.balanceChartData = {
                  labels: labels,
                  datasets: [
                    {
                      label: 'Balance Mensual ($)',
                      data: balance,
                      backgroundColor: balance.map(val => val >= 0 ? '#28a745' : '#dc3545'), // Verde si positivo, rojo si negativo
                      borderWidth: 1
                    }
                  ]
                };
        
        this.balanceChartOptions = {
          responsive: true,
          scales: {
            x: {
              title: {
                display: true,
                text: 'Mes'
              }
            },
            y: {
              title: {
                display: true,
                text: 'Balance ($)'
              },
              ticks: {
                callback: value => `$${value}`
              }
            }
          },
          plugins: {
            tooltip: {
              callbacks: {
                label: ctx => `Balance: $${ctx.formattedValue}`
              }
            }
          }
        };
        */

        //const balanceMensual = ganancias.map((g, i) => g - (gastos[i] || 0));
        this.comparativoChartData = {
          labels,
          datasets: [
            {
              label: 'Ventas',
              data: ventas,
              backgroundColor: 'rgba(0, 123, 255, 0.7)', // azul
              hoverBackgroundColor: 'rgba(0, 123, 255, 0.3)',
              barPercentage: 0.6,
              borderRadius: 4
            },
            {
              label: 'Ganancias',
              data: ganancias,
              backgroundColor: 'rgba(40, 167, 69, 0.7)', // verde
              hoverBackgroundColor: 'rgba(40, 167, 69, 0.3)',
              barPercentage: 0.6,
              borderRadius: 4
            },
            {
              label: 'Egresos',
              data: gastos,
              backgroundColor: 'rgba(220, 53, 69, 0.7)', // rojo
              hoverBackgroundColor: 'rgba(220, 53, 69, 0.3)',
              barPercentage: 0.6,
              borderRadius: 4
            }
          ]
        };

        this.comparativoChartOptions = {
          responsive: true,
          plugins: {
            tooltip: {
              callbacks: {
                label: ctx => {
                  const val = ctx.raw as number;
                  return `${ctx.dataset.label}: $${val}`;
                }
              }
            },
            title: {
              display: true,
              text: '📈 Comparativo mensual: Ventas, Ganancias y Egresos'
            },
            legend: {
              position: 'top'
            }
          },
          scales: {
            x: {
              stacked: false,
              title: {
                display: true,
                text: 'Mes'
              }
            },
            y: {
              beginAtZero: true,
              title: {
                display: true,
                text: 'Monto ($)'
              },
              ticks: {
                callback: value => `$${value}`
              }
            }
          }
        };

        // Gráfico comparativo Ventas vs Gastos (combinado)
        const balanceMensual = ventas.map((v, i) => v - (gastos[i] || 0));
        const coloresBalance = balanceMensual.map(val => val >= 0 ? 'rgba(40, 167, 69, 0.7)' : 'rgba(220, 53, 69, 0.7)');

        this.balanceChartData = {
          labels,
          datasets: [
            {
              label: 'Balance Mensual',
              data: balanceMensual,
              backgroundColor: coloresBalance,
              hoverBackgroundColor: coloresBalance.map(color =>
                color.replace(/0\.7\)/, '0.3)') // reemplaza la opacidad 0.7 por 0.3
              ), // agregar esto para hover
              borderRadius: 5,
              barPercentage: 0.6
            }
          ]
        };

        this.balanceChartOptions = {
          responsive: true,
          plugins: {
            tooltip: {
              callbacks: {
                label: ctx => {
                  const val = ctx.raw as number;;
                  return val >= 0 ? `Ganancia: $${val}` : `Pérdida: $${Math.abs(val)}`;
                }
              }
            },
            title: {
              display: true,
              text: '📊 Balance mensual (Ganancia o Pérdida)'
            },
            legend: { display: false }
          },
          scales: {
            x: {
              title: { display: true, text: 'Mes' }
            },
            y: {
              beginAtZero: true,
              title: { display: true, text: 'Balance ($)' },
              ticks: {
                callback: value => `$${value}`
              }
            }
          },

        };


        // Armo cards día
        this.statsDay = [
          {
            title: 'Ventas del día',
            value: this.totalVenta,
            percent: this.porVenta,
            icon: 'fas fa-dollar-sign',
            bgClass: 'bg-success'
          },
          {
            title: 'Ganancias del día',
            value: this.totalGanancia,
            percent: this.porGanancia,
            icon: 'fas fa-chart-line',
            bgClass: 'bg-primary'
          },
          {
            title: 'Gastos del día',
            value: this.totalGastos,
            percent: this.porGastos,
            icon: 'fas fa-credit-card',
            bgClass: 'bg-danger'
          }
        ];

        // Armo cards mes
        this.statsMonth = [
          {
            title: 'Ventas del mes',
            value: this.totalVentaM,
            percent: this.porVenta,
            icon: 'fas fa-dollar-sign',
            bgClass: 'bg-success'
          },
          {
            title: 'Ganancias del mes',
            value: this.totalGananciaM,
            percent: this.porGanancia,
            icon: 'fas fa-chart-line',
            bgClass: 'bg-primary'
          },
          {
            title: 'Gastos del mes',
            value: this.totalGastosM,
            percent: this.porGastos,
            icon: 'fas fa-credit-card',
            bgClass: 'bg-danger'
          }
        ];
      }
    } catch (error) {
      console.error('Error al cargar el tablero:', error);
    } finally {
      this.cargando = false
    }
  }

}
